import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import { Flex, Text } from '../basic';
import ShowIf from '../dataDisplay/ShowIf';
import { sortByKeys } from '../../../../helpers/array.helper';

export default function SelectBox(props) {
  const {
    defaultValue, selection, values, loading, label: { translationId, value: labelValue }, keys: { id, descripcion }, onSelect, visible, sortBy, filterBy,
  } = props;
  const sortedValues = sortByKeys(sortBy, values);
  return (
    <Flex flexDirection="column" width="100%" mr="16px">
      <ShowIf condition={visible || visible === undefined}>
        <Text m="0 0 8px 0" color="#4A4A4A" lineHeight="20px" fontSize="16px" translationId={translationId}>{labelValue}</Text>
        <Select
          showSearch={filterBy !== null}
          size="large"
          defaultValue={defaultValue}
          value={selection}
          loading={loading}
          onSelect={selection => onSelect(selection)}
          filterOption={(input, { props: optionProps }) => (optionProps.children.toLowerCase().indexOf(input.toLowerCase()) >= 0)}
        >
          {sortedValues.map(value => <Select.Option value={value[id]}>{value[descripcion]}</Select.Option>)}
        </Select>
      </ShowIf>
    </Flex>
  );
}
SelectBox.propTypes = {
  label: PropTypes.shape({ translationId: PropTypes.string.isRequired, value: PropTypes.string }).isRequired,
  defaultValue: PropTypes.shape({}),
  loading: PropTypes.bool,
  visible: PropTypes.bool,
  filterBy: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.shape({})),
  sortBy: PropTypes.arrayOf(PropTypes.shape({})),
  keys: { id: PropTypes.string, descripcion: PropTypes.string },
  selection: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelect: PropTypes.func,
};
SelectBox.defaultProps = {
  values: [],
  defaultValue: null,
  loading: false,
  keys: { id: 'id', descripcion: 'descripcion' },
  sortBy: {},
  selection: null,
  visible: true,
  filterBy: null,
  onSelect: () => {},
};
